import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode, Navigation, Pagination } from "swiper/modules";
import { motion, AnimatePresence } from "framer-motion";
import "../../assets/style/swiper-custom.css";
import axios from "axios";
import base_url from "../../constants/global";

export default function Intro() {
  const [index, setIndex] = useState(0);
  const [data, setData] = useState([]);

  useEffect(() => {
    axios
      .post(`${base_url}/home_page`)
      .then((response) => {
        setData(response.data.banner || []);
      })
      .catch((err) => console.error("Error fetching banners:", err));
  }, []);

  useEffect(() => {
    if (!data.length) return;
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % data.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [data]);

  if (!data.length) return <div className="text-center py-10">No Data</div>;

  return (
    <div className="md:pt-24 bg-gradient-to-br from-pikkat-green/10 to-pikkat-green/10 via-white flex justify-center px-3 overflow-hidden">
      <div className="flex flex-col items-center md:grid grid-flow-col grid-cols-12 container mx-auto">

        {/* ---------- TEXT SECTION ---------- */}
        <div className="col-span-6 flex flex-col justify-between overflow-hidden">
          <AnimatePresence mode="wait">
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -60 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 60 }}
              transition={{ duration: 0.7, ease: "easeInOut" }}
              className="flex flex-col gap-7 py-4 text-left pt-[5em]"
            >
              <h1 className="text-3xl md:text-5xl font-semibold xl:pr-24">
                {data[index].title}
              </h1>

              <img
                src={require("../../assets/curved-line.png")}
                className="w-[359px]"
                alt="intro line"
              />

              <p className="font-medium text-pikkat-gray-2/90 md:text-xl text-justify xl:pr-32">
                {data[index].description}
              </p>

              <a
                className="bg-pikkat-red text-pikkat-white rounded-xl text-[13px] max-w-[200px] p-3 flex flex-row items-center justify-evenly hover:bg-pikkat-red/90 transition-colors"
                href={data[index].link_url}
                target="_blank"
                rel="noopener noreferrer"
              >
                Belanja Sekarang
                <img
                  src={require("../../assets/icons/arrow-up-right-1.png")}
                  alt="arrow"
                />
              </a>
            </motion.div>
          </AnimatePresence>
        </div>

        {/* ---------- IMAGE SECTION (motion-controlled) ---------- */}
        <div className="relative col-span-6 flex flex-col justify-center max-w-[320px] md:max-w-max overflow-hidden">
          <img
            src={require("../../assets/intro-background.png")}
            alt="intro background"
            className="scale-[90%] hidden md:block object-cover absolute translate-x-12 opacity-60"
          />

          {/* Motion wrapper di luar Swiper */}
          <AnimatePresence mode="wait">
            <motion.div
              key={index}
              initial={{ opacity: 0, x: 80, scale: 0.95 }}
              animate={{ opacity: 1, x: 0, scale: 1 }}
              exit={{ opacity: 0, x: -80, scale: 0.95 }}
              transition={{ duration: 0.8, ease: "easeInOut" }}
              className="z-40 scale-75"
            >
              <Swiper
                slidesPerView={1}
                spaceBetween={10}
                freeMode={false}
                pagination={{ clickable: true }}
                autoplay={{
                  delay: 5000,
                  disableOnInteraction: false,
                }}
                modules={[Autoplay, FreeMode, Pagination, Navigation]}
                className="mySwiper bg-cover swiper"
              >
                <SwiperSlide key={data[index].id}>
                  <div
                    style={{ backgroundColor: data[index].bgColor }}
                    className="flex justify-center items-center rounded-lg group md:m-8"
                  >
                    <img
                      src={data[index].images}
                      alt={data[index].title}
                      className="rounded-2xl h-[450px] object-cover"
                    />
                  </div>
                </SwiperSlide>
              </Swiper>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
}
